import { render } from "./ConsigneePartial.html?vue&type=template&id=96abbdde&scoped=true"
import script from "./ConsigneePartial.js?vue&type=script&lang=js"
export * from "./ConsigneePartial.js?vue&type=script&lang=js"

import "./ConsigneePartial.scss?vue&type=style&index=0&id=96abbdde&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96abbdde"]])

export default __exports__